import {
  TablePage,
  AddPage,
  EditPage,
  ViewPage,
} from 'src/views/crewmaster'
import pathMap from 'src/paths/pathMap'

class CrewMasterRoute {
  getConfigurations() {
    return [
      {
        exact: true,
        path: pathMap.CREW_MASTER_LIST_VIEW,
        component: TablePage
      },
      {
        exact: true,
        path: pathMap.CREW_MASTER_ADD_VIEW,
        component: AddPage
      },
      {
        exact: true,
        path: pathMap.CREW_MASTER_EDIT_VIEW,
        component: EditPage
      },
      {
        exact: true,
        path: pathMap.CREW_MASTER_DETAILS_VIEW,
        component: ViewPage
      }
    ]
  }
}

export default CrewMasterRoute
